<template class="">
  <div class="row">
    <div class="col-md-12">
      <div class="category-top-bar" style="margin-top: 20px;">
        <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="() => {$router.push('/feedback')}">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p>
          <button class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="saveComment" :title="$t('general.save')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
        </div>
      </div>
    </div>
    <div class="col-lg-10 col-md-12 pad-to-15">
      <div class="card feedback-card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-7 feedback-sides">
              <p class="feedback-top">
                <span class="label" :class="'label-' + feedbackTypeClass(message.type)" >{{$t('feedbackTypes.' + message.type)}}</span>
                <span class="time">{{formatDateTime(message.created_at)}}</span>
                <span v-if="message.location" class="time"><span class="text-bold">{{$t('dashboard.selectLocation') }}</span> {{ message.location }}</span>
              </p>
              <h6>{{message.creater.firstname ? message.creater.firstname : ''}} {{message.creater.lastname ? message.creater.lastname : ''}}</h6>
              <div>{{message.text}}</div>
              <form>
                <div class="form-group mt-5">
                  <label>{{$t('feedback.response')}}</label>
                  <textarea name="adminResponse" rows="6"
                        :placeholder="$t('feedback.response')"
                        v-validate="{required: true}"
                        v-model="message.admin_response"
                        class="form-control"></textarea>
                  <p>
                    <i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('feedback.send')}}.
                  </p>
                </div>
                <!-- <button type="submit" @click.prevent="saveComment" class="btn btn-icon btn-success" :title="$t('general.save')"><i class="ti-save"></i></button>
                <button type="text" class="btn btn-danger btn-icon" :title="$t('general.delete')" @click.prevent="deleteComment"> <i class="ti-close"></i></button> -->
              </form>
            </div>
            <div class="col-md-5 feedback-sides">
              <h6 class="mar-to-0"> <img class="icon-card-header" src="/static/img/icons/user-sm.png">  {{$t('customers.title')}}</h6>
              <hr class="sm">
              <div class="row pad-bt-10">
                <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><span>{{$t('customers.name')}}</span></div>
                <div class="col-lg-8 col-sm-7 col-xs-12">{{message.creater.firstname ? message.creater.firstname : ''}} {{message.creater.lastname ? message.creater.lastname : ''}}</div>
              </div>
              <div class="row pad-bt-10">
                <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><span>{{$t('customers.email')}}</span></div>
                <div class="col-lg-8 col-sm-7 col-xs-12">{{message.creater.email ? message.creater.email : '-'}}</div>
              </div>
              <div class="row pad-bt-10">
                <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><span>{{$t('customers.phone')}}</span></div>
                <div class="col-lg-8 col-sm-7 col-xs-12">{{message.creater.phone ? message.creater.phone : '-'}}</div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import TimeLine from './../../Dashboard/Stats/TimeLine.vue'
  import TimeLineItem from './../../Dashboard/Stats/TimeLineItem.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      TimeLine,
      TimeLineItem
    },
    data () {
      return {
        message: {},
        loading: true
      }
    },
    created: function () {
      this.$nextTick(function () { this.loading = true })

      if (this.$route.params.id) {
        var id = this.$route.params.id
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/feedback/' + id, 'GET', data, (response) => {
          if (response.status === true) {
            this.message = response.data[0]
            this.$nextTick(function () { this.loading = false })
            if (response.data[0].seen === 0) {
              this.apiRequest('/feedback/' + id, 'DELETE', data, function (response) {
              })
            }
          }
        })
      }
    },
    methods: {
      saveComment () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.errors.clear()
            this.$nextTick(() => { this.loading = true })
            var id = this.$route.params.id
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              admin_response: this.message.admin_response
            }
            this.apiRequest('/feedback/admin-comment/' + id, 'PUT', data, (response) => {
              this.$nextTick(() => { this.loading = false })
            })
          }
        })
      },
      deleteComment () {
        var self = this
        self.message.admin_response = ' '
        self.$nextTick(function () { self.loading = true })
        var id = this.$route.params.id
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          admin_response: ''
        }
        this.apiRequest('/feedback/admin-comment/' + id, 'PUT', data, function (response) {
          self.$nextTick(function () { self.loading = false })
        })
      }
    }
  }
</script>
<style>
  .table tbody tr:first-of-type > td{
    border-top: 0px solid #fff;
  }
  .mt-5 {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Feedback/FeedbackView.vue